const KEY = "pressops_activity";
const ERR = "pressops_last_error";

export const recordActivity = (entry) => {
  const list = JSON.parse(sessionStorage.getItem(KEY) || "[]");
  if (list[list.length - 1]?.route === entry.route && entry.type === "visit") return;
  sessionStorage.setItem(KEY, JSON.stringify([...list, { ...entry, at: new Date().toISOString() }].slice(-15)));
};

export const recordError = (e) => {
  sessionStorage.setItem(ERR, JSON.stringify({ at: new Date().toISOString(), url: e.config?.url, status: e.response?.status, detail: String(e.response?.data?.detail || e.message).slice(0, 300) }));
};

const MODULES = { jobs: "operations", quotes: "estimating", invoices: "invoicing", payments: "invoicing", crm: "crm", inventory: "inventory", procurement: "procurement", maintenance: "maintenance", accounting: "accounting", hr: "hr", payroll: "payroll", reports: "reporting", customers: "customers" };
const TYPES = { jobs: "job", quotes: "quote", invoices: "invoice" };

export const pageContext = (pathname, extra = {}) => {
  const [, , seg, id] = pathname.split("/");
  const ctx = { route: pathname + window.location.search, module: MODULES[seg] || seg || "dashboard" };
  if (TYPES[seg] && id && !["new"].includes(id)) Object.assign(ctx, { record_type: TYPES[seg], record_id: id });
  return { ...ctx, ...extra, recent_actions: JSON.parse(sessionStorage.getItem(KEY) || "[]"), error_snapshot: JSON.parse(sessionStorage.getItem(ERR) || "null") };
};
